/*
 * Vendor Registrations — migrated from Sprockets vendor_registrations.js
 * AG Grid v35 APIs + Algolia addWidgets fix
 */
const AgGridPagination = require('../v4/components/ag_grid_pagination');

window.WorkplaceVendorRegistrations = {
    _registrationsSearch: null,
    _gridApi: null,
    _gridOptions: null,
    _initCall: true,

    emptyCallHandler() {
        if (this._initCall) {
            $('.search-results-container').hide();
            $('#spinner').hide();
            return $('.empty-page').removeClass('hidden');
        }
    },

    reloadData(data) {
        this._initCall = false;
        this._gridApi.setGridOption('rowData', data);
        $('#registrations-grid').parent().removeClass('hidden');
        $('.actions').removeClass('hidden');
        $('#spinner').hide();
        return this._resizeTable();
    },

    _resizeTable() {
        return resizeAgGridTable('#registrations-table', this._gridOptions, 1, this._currentDataSize, 48);
    },

    _initializeWidgets(app_id, key, index) {
        const registrationsSearch = (this._registrationsSearch = SearchUtils.createInstantSearch(app_id, key, index));

        registrationsSearch.addWidgets([
            instantsearch.widgets.configure({ hitsPerPage: 2000 })
        ]);

        if ($('.search-filters').length > 0) {
            const states = WorkplaceVendorRegistrations.vendor_registration_enabled ? ['Submitted', 'Approved', 'Rejected', 'Expired'] : ['Incomplete', 'Submitted', 'Approved', 'Rejected', 'Expired'];
            registrationsSearch.addWidgets([
                Widgets.statsWidget(),
                Widgets.searchBoxWidget(I18n.t('vendor.registrations.filters.enter_keyword')),
                Widgets.clearAllWidget(),
                Widgets.stateWidget(states),
                Widgets.currentRefinedValuesWidget()({ excludedAttributes: [] }),
                Widgets.registrationTypesWidget(),
                Widgets.submittedAtWidget(),
                Widgets.approvedAtWidget(),
                Widgets.validityWidget()
            ]);
        }

        registrationsSearch.addWidgets([Widgets.vendorRegistrationsHitsWidget()({})]);
        return registrationsSearch.start();
    },

    nameRenderer(params) {
        if (WorkplaceVendorRegistrations.vendor_registration_enabled) {
            return params.data.vendor_name;
        } else {
            return params.data.registrar_name;
        }
    },

    stateRenderer(params) {
        if (!params.data.state) { return ''; }

        const state = I18n.t(`registration_states.${params.data.state}`);
        return `<div class='status-label registration-status ${WorkplaceUtils.dasherize(params.data.state)}'>${state}</div>`;
    },

    registrationTypeRenderer(params) {
        return params.data.registration_type;
    },

    _submittedAtRenderer(row) {
        if (!!row.data.submitted_at) {
            const m = moment.unix(row.data.submitted_at);
            if (m.isValid()) { return m.format('MMM DD, YYYY'); } else { return ''; }
        }
    },

    _approvedAtRenderer(row) {
        if (!!row.data.approved_at) {
            const m = moment.unix(row.data.approved_at);
            if (m.isValid()) { return m.format('MMM DD, YYYY'); } else { return ''; }
        }
    },

    _validFromRenderer(row) {
        if (!!row.data.valid_from) {
            const m = moment.unix(row.data.valid_from);
            if (m.isValid()) { return m.format('MMM DD, YYYY'); } else { return ''; }
        }
    },

    _validUntilRenderer(row) {
        if (!!row.data.valid_until) {
            const m = moment.unix(row.data.valid_until);
            if (m.isValid()) { return m.format('MMM DD, YYYY'); } else { return ''; }
        }
    },

    _submittedAtComparator(valueA, valueB, nodeA, nodeB) {
        return WorkplaceUtils.compareNodeNumbers(valueA, valueB, nodeA, nodeB, 'submitted_at');
    },

    _approvedAtComparator(valueA, valueB, nodeA, nodeB) {
        return WorkplaceUtils.compareNodeNumbers(valueA, valueB, nodeA, nodeB, 'approved_at');
    },

    _validFromComparator(valueA, valueB, nodeA, nodeB) {
        return WorkplaceUtils.compareNodeNumbers(valueA, valueB, nodeA, nodeB, 'valid_from');
    },

    _validUntilComparator(valueA, valueB, nodeA, nodeB) {
        return WorkplaceUtils.compareNodeNumbers(valueA, valueB, nodeA, nodeB, 'valid_until');
    },

    initializeTable(app_id, key, index) {
        this._initializeWidgets(app_id, key, index);

        const columnDefs = [
            {
                headerName: I18n.t('vendor.registrations.index.number'),
                field: 'number',
                width: 150
            },
            {
                headerName: I18n.t('vendor.registrations.index.company'),
                field: 'name',
                width: 350,
                cellRenderer: this.nameRenderer
            },
            {
                headerName: I18n.t('vendor.registrations.index.registration_type'),
                field: 'registration_type',
                cellRenderer: this.registrationTypeRenderer
            },
            {
                headerName: I18n.t('vendor.registrations.index.status'),
                field: 'state',
                width: 125,
                cellRenderer: this.stateRenderer
            },
            {
                headerName: I18n.t('vendor.registrations.index.submitted'),
                field: 'submitted_at',
                width: 125,
                comparator: this._submittedAtComparator,
                cellRenderer: this._submittedAtRenderer,
                sort: 'desc'
            },
            {
                headerName: I18n.t('vendor.registrations.index.approved'),
                field: 'approved_at',
                width: 125,
                cellRenderer: this._approvedAtRenderer,
                comparator: this._approvedAtComparator
            },
            {
                headerName: I18n.t('vendor.registrations.index.valid_from'),
                field: 'valid_from',
                width: 125,
                cellRenderer: this._validFromRenderer,
                comparator: this._validFromComparator
            },
            {
                headerName: I18n.t('vendor.registrations.index.valid_until'),
                field: 'valid_until',
                width: 125,
                cellRenderer: this._validUntilRenderer,
                comparator: this._validUntilComparator
            }
        ];

        this._gridOptions = {
            paginationPageSize: 48,
            headerHeight: 44,
            rowHeight: 44,
            pagination: true,
            suppressPaginationPanel: true,
            columnDefs,
            defaultColDef: {
                sortable: true,
                resizable: true
            },
            rowStyle: { cursor: 'pointer' },
            onRowClicked(e) {
                if (WorkplaceVendorRegistrations.vendor_registration_enabled) {
                    return window.location.href = `/companies/${e.data.registrar_slug}/vendor/registrations/${e.data.objectID}`;
                } else {
                    return window.location.href = `/companies/${e.data.registrar_slug}/vendor/registrations/${e.data.objectID}/edit`;
                }
            },
            onGridReady(e) {
                return e.api.sizeColumnsToFit();
            },
            onGridSizeChanged(event) {
                return event.api.sizeColumnsToFit();
            }
        };
        const agGridPagination = AgGridPagination.initialize(this._gridOptions);
        this._gridOptions.onPaginationChanged = agGridPagination.renderPagination.bind(agGridPagination);

        $('#pagination').exists().on('click', () => {
            const {
                paginationProxy
            } = this._gridApi;
            this._currentDataSize = (paginationProxy.bottomRowIndex - paginationProxy.topRowIndex) + 1;
            return this._resizeTable();
        });

        const gridDiv = document.getElementById('registrations-table');
        this._gridApi = agGrid.createGrid(gridDiv, this._gridOptions);
        this._gridOptions.api = this._gridApi;
        return AgGridPagination.initializePaginationListeners();
    },

    initializeCSVExport() {
        const _this = this;
        return $('#export-registrations-csv').click(function (e) {
            e.preventDefault();
            const algoliaQuery = _this._registrationsSearch.helper.getQuery();
            return $.pseudoAjax({
                url: $(this).attr('href'),
                key: 'algolia_query',
                data: JSON.stringify(algoliaQuery)
            });
        });
    }

};
